import { render } from "./StudentFollowUps.vue?vue&type=template&id=f1225c94&scoped=true"
import script from "./StudentFollowUps.vue?vue&type=script&lang=js"
export * from "./StudentFollowUps.vue?vue&type=script&lang=js"

import "./StudentFollowUps.vue?vue&type=style&index=0&id=f1225c94&scoped=true&lang=css"
import "./followUps.css?vue&type=style&index=1&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1225c94"]])

export default __exports__